import React from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Column } from '@pella/sash-framework';
import { Image } from '../../../';

const RatingsFeature = ({ data, className, ...other }) => {
	if (!data) return null;

	return (
		<div
			className={`ratingsFeature py-6 md:py-8 xl:py-12 ${className || ''}`}
			{...other}
		>
			<Container>
				<Row align='center'>
					{data.image?.[0] && (
						<Column
							xl={7}
							className='max-xl:hidden'
						>
							<Image data={data.image[0]} />
						</Column>
					)}

					<Column xs='fluid'>
						{data.subheading && (
							<div
								className='ratingsFeature-subhead mb-4 mt-2 flex items-center text-xs font-semibold before:mr-2 before:inline-block before:h-2.5 before:w-2.5 before:rounded before:bg-primary before:content-[""] md:mb-2.5 xl:mb-5 xl:text-lg'
								dangerouslySetInnerHTML={{ __html: data.subheading }}
							/>
						)}
						{data.heading && (
							<div
								className='ratingsFeature-head font-semibold'
								dangerouslySetInnerHTML={{ __html: data.heading }}
							/>
						)}
					</Column>
				</Row>
			</Container>
		</div>
	);
};

RatingsFeature.propTypes = {
	data: PropTypes.object,
	className: PropTypes.string,
};

export default RatingsFeature;
